import React, { useContext, useState } from "react";
import { LoanFormContext } from "./LoanForm";
import FormStep from "../../FormStep";
import { Button } from "./../Controls";

const PlanToBuy: React.FunctionComponent<{
  onSubmit?: (value: string) => void;
}> = (props: { onSubmit?: (value: string) => void }) => {
  const loanFormContext = useContext(LoanFormContext);

  const handleSubmit = (value: string) => {
    if (props.onSubmit) props.onSubmit(value);
  };

  return (
    <div>
      <FormStep
        header={
          <h1 className="heading-main">
            Have you already found your new home?
          </h1>
        }
      >
        <div className="form-inputs-wrapper">
          <Button
            label="Already under contract"
            onClick={() => {
              handleSubmit("already under contract");
            }}
            block
            anim
            active={
              loanFormContext.planToBuy?.value === "already under contract"
                ? true
                : false
            }
          />
          <Button
            label="Immediately – I’m making an offer"
            onClick={() => {
              handleSubmit("immediately");
            }}
            block
            anim
            active={
              loanFormContext.planToBuy?.value === "immediately" ? true : false
            }
          />
          <Button
            label="I’m shopping & am considering a few options"
            onClick={() => {
              handleSubmit("shopping and am considering a few options");
            }}
            block
            anim
            active={
              loanFormContext.planToBuy?.value ===
              "shopping and am considering a few options"
                ? true
                : false
            }
          />
          <Button
            label="Within next couple months"
            onClick={() => {
              handleSubmit("within next couple months");
            }}
            block
            anim
            active={
              loanFormContext.planToBuy?.value === "within next couple months"
                ? true
                : false
            }
          />
        </div>
      </FormStep>
    </div>
  );
};

export default PlanToBuy;
